import { FC } from 'react';

import { Colors } from '@lichtblick/theme';
import { Headline, Text } from '@lichtblick/ui-components';

import { Card, Hint, InnerContentWrapper, InterfererRoot, OuterContentWrapper } from './CasesSliderCard.styles';

import { ElementMappers, isRichTextEmpty, RichText } from '../../../helpers/RichText';
import { CasesSliderCardType } from '../../../types';
import { AButton } from '../../AButton';
import { AImageProps, AImage } from '../../AImage';
import { InterfererProps } from '../shared/Interferer/Interferer';
import { Listing, ListingProps } from '../shared/Listing';

export type StromWalletSliderCardProps = ListingProps & {
  finePrint: string;
  headline: string;
  image: AImageProps;
  interferer: string;
  text: string;
};

const elementMappers: Partial<ElementMappers> = {
  p: ({ children }) => (
    <Text isBold renderAs="p" size="Xs">
      {children}
    </Text>
  ),
};

const Interferer: FC<Partial<InterfererProps>> = ({ text }) => {
  const isInterfererEmpty = isRichTextEmpty(text);

  return isInterfererEmpty ? null : (
    <InterfererRoot>
      <RichText elementMappers={elementMappers} richText={text} />
    </InterfererRoot>
  );
};

export const CasesSliderCard: FC<CasesSliderCardType & { backgroundColor: Colors }> = ({
  backgroundColor,
  button,
  details,
  finePrint,
  headline,
  image,
  interferer,
  text,
}) => (
  <Card $backgroundColor={backgroundColor}>
    <AImage {...image[0]} isBackground />
    <Interferer text={interferer} />
    <OuterContentWrapper>
      <InnerContentWrapper>
        <Headline size="S">{headline}</Headline>
        <Text size="M">{text}</Text>
        {Boolean(details?.length) && (
          <Listing
            backgroundColor={backgroundColor === Colors.White ? Colors.FadedMoss : Colors.White}
            rows={details}
          />
        )}
        <Hint size="Xs">{finePrint}</Hint>
      </InnerContentWrapper>
      {button?.length === 1 && <AButton {...button[0]} variant="link" />}
    </OuterContentWrapper>
  </Card>
);
